import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/Iomniclogo.png'
import _imports_1 from '@/assets/Iomnicicon.png'


const _hoisted_1 = {
  key: 0,
  class: "top-sidebar"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("a", { href: "/home" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "logo-img",
    width: "130",
    src: _imports_0
  })
], -1)
const _hoisted_3 = {
  key: 1,
  class: "top-sidebar"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("a", { href: "/home" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "logo-img",
    width: "37",
    src: _imports_1
  })
], -1)
const _hoisted_5 = { style: {"margin":"65px auto","text-align":"center"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_el_menu_item = _resolveComponent("el-menu-item")
  const _component_el_submenu = _resolveComponent("el-submenu")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_menu = _resolveComponent("el-menu")
  const _component_el_aside = _resolveComponent("el-aside")

  return (_openBlock(), _createBlock(_component_el_aside, {
    style: {"width":"180px"},
    class: ["sidebar el-menu-vertical-demo", _ctx.isCollapse ? 'sidebar-display' : '']
  }, {
    default: _withCtx(() => [
      (!_ctx.isCollapse)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_3, [
            _hoisted_4
          ])),
      _createVNode(_component_el_menu, {
        "default-active": _ctx.currentRoter,
        class: "",
        "background-color": "#fff",
        "text-color": "#2c3e50",
        router: true,
        collapse: _ctx.isCollapse
      }, {
        default: _withCtx(() => [
          (_ctx.accounts.length > 1)
            ? (_openBlock(), _createBlock(_component_el_select, {
                key: 0,
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleChangeAccount())),
                modelValue: _ctx.accountSelectedId,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.accountSelectedId = $event)),
                style: {"margin":"12px"},
                placeholder: "Select",
                size: "large"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.accounts, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.id,
                      label: item.name,
                      value: item.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.sidebars, (item, itemIndex) => {
            return (_openBlock(), _createBlock(_Fragment, { key: itemIndex }, [
              (item.children && !_ctx.isCollapse)
                ? (_openBlock(), _createBlock(_component_el_submenu, {
                    key: 0,
                    index: item.url
                  }, {
                    title: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        class: "icon-sidebar",
                        icon: item.icon,
                        "fixed-width": ""
                      }, null, 8, ["icon"]),
                      _createVNode("span", null, _toDisplayString(item.name), 1)
                    ]),
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.children.subItem, (sub, subindex) => {
                        return (_openBlock(), _createBlock(_component_el_menu_item, {
                          key: subindex,
                          index: item.url + '/' + sub.url
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(sub.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["index"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["index"]))
                : (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 1,
                    index: item.url
                  }, {
                    title: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_font_awesome_icon, {
                        class: "icon-sidebar",
                        icon: item.icon,
                        "fixed-width": ""
                      }, null, 8, ["icon"])
                    ]),
                    _: 2
                  }, 1032, ["index"]))
            ], 64))
          }), 128)),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              onClick: _ctx.showSidebar,
              icon: _ctx.icon,
              size: "large",
              circle: ""
            }, null, 8, ["onClick", "icon"])
          ])
        ]),
        _: 1
      }, 8, ["default-active", "collapse"])
    ]),
    _: 1
  }, 8, ["class"]))
}